import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface ApiStatusIndicatorProps {
    isLoading: boolean;
    error?: Error;
    loadingMessage: string;
    errorMessage: string;
}
export const ApiStatusIndicator: React.FC<ApiStatusIndicatorProps> = ({
    isLoading,
    error,
    loadingMessage,
    errorMessage,
}) => {
    if (!isLoading && !error) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '4px',
            }}
        >
            {isLoading && (
                <>
                    <CircularProgress size={24} color="primary" sx={{ marginRight: '8px' }} />
                    <Typography>{loadingMessage}</Typography>
                </>
            )}
            {error && (
                <>
                    <ErrorOutlinedIcon color="error" sx={{ marginRight: '8px' }} />
                    <Typography>{errorMessage}</Typography>
                </>
            )}
        </Box>
    );
};

export default ApiStatusIndicator;
